import { FaYoutube } from "react-icons/fa6";
import { IoMdArrowBack } from "react-icons/io";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function Overview() {
  return (
    <>
      <div className="trending">
        <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
          <IoMdArrowBack /> Go Back
        </button>{" "}
        <div className="group-chat-container overview-img">
          <div className="single-chat">
            <a
              className="text-white btn btn-primary "
              href="https://www.youtube.com/watch?v=vy3CB-v5NFw"
              target="_blank"
            >
              <FaYoutube className="youtube-icon" /> Play Video
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Overview;
